import React from 'react';

/**
 * Stat tiles row — uses `.page-stats` / `.page-stat` from PageShell.
 * @param {{ value: React.ReactNode, label: React.ReactNode }[]} items
 */
function PageStats({ items, ariaLabel }) {
  return (
    <div className="page-stats" role="region" aria-label={ariaLabel}>
      {items.map(({ value, label }, i) => (
        <div key={i} className="page-stat">
          <div className="page-stat__val">{value}</div>
          <div className="page-stat__lbl">{label}</div>
        </div>
      ))}
    </div>
  );
}

export default PageStats;
